import type {
  ListKeyChannelBindingsResponse,
  SetKeyChannelBindingsRequest,
  SetKeyChannelBindingsResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listBindings(
  upstreamId: string,
  bucketId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<ListKeyChannelBindingsResponse> {
  return opsApiRequest<ListKeyChannelBindingsResponse>(
    `/v1/ops/upstreams/${upstreamId}/key-buckets/${bucketId}/channels`,
    { method: 'GET' },
    fetchImpl,
  );
}

export function setBindings(
  upstreamId: string,
  bucketId: string,
  body: SetKeyChannelBindingsRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<SetKeyChannelBindingsResponse> {
  return opsApiRequest<SetKeyChannelBindingsResponse>(
    `/v1/ops/upstreams/${upstreamId}/key-buckets/${bucketId}/channels`,
    {
      method: 'PUT',
      headers: { 'content-type': 'application/json' },
      body,
    },
    fetchImpl,
  );
}
